const WizardDescription = ({ children, className = '' }) => {
  return <div className={`comp-wizard-description ${className}`}>{children}</div>;
};

export default WizardDescription;
